import { create } from 'zustand';
type ButtonState = {
	id: string;
	isLoading: boolean;
};

type UseSubscriptionStoreProps = {
	buttonState?: ButtonState;
	setButtonState: (buttonState: ButtonState) => void,
};

export const useSubscriptionStore = create<UseSubscriptionStoreProps>((set) => ({
	buttonState: undefined,
	setButtonState: (buttonState) => set(() => ({ buttonState })),
}));
